import { render, staticRenderFns } from "./GroupSection.vue?vue&type=template&id=80e8e118"
import script from "./GroupSection.vue?vue&type=script&lang=js"
export * from "./GroupSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports